<template>
  <div class="my-calendar">
    <div class="model" v-if="isModelData" @click="handleModelClose">
      <div class="model-data" @click="stopClose($event)">
        <div class="model-head">
          <div class="head-left">
            <div class="calendar" @click="handleLeftData" :class="curActive ? 'active' : ''">{{ cutTime }}</div>
          </div>
          <p class="ok" @click="confirmDataOk">确定</p>
        </div>
        <div class="model-main">
          <div class="model-btm">
            <van-calendar
              v-if="showModalLeftPicker"
              :poppable="false"
              :show-title="false"
              :show-confirm="false"
              :show-mark="false"
              :show-subtitle="false"
              :style="{ height: '360px' }"
              @select="handleCalendar"
              :formatter="formatter"
              first-day-of-week="1"
              :min-date="minDate"
              :max-date="maxDate"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      cutTime: '',
      cutTimeTemp: '',
      cutRightTime: '',
      isModelData: false,
      minDate: new Date(2020, 0, 1), // 最小日期
      maxDate: new Date(2050, 0, 31),
      minRightDate: new Date(),
      showModalLeftPicker: true,
      showModalRightPicker: false,
      curActive: true,
    }
  },
  mounted() {
    const date = new Date()
    this.cutTime = this.$moment(date * 1).format(
      'YYYY年MM月DD日'
    )
    this.cutRightTime = this.$moment(date * 1).format(
      'HH:mm'
    )
  },
  methods: {
    // 自定义日期格式化
    formatter(day) {
      const date = new Date(day.date)
      const isMonday = date.getDay() === 1 // 判断是否为周一
      const isToday = date.toDateString() === new Date().toDateString() // 判断是否是当天
      // 如果是周一，添加高亮样式
      if (isMonday) {
        day.className = 'highlight-monday' // 自定义样式类名
      } else {
        if (!isToday) {
          day.type = 'disabled'
          day.className = 'highlight-disabled'
        }
      }
      return day
    },

    init() {
      this.isModelData = true
      this.curActive = true
      this.showModalLeftPicker = true
    },
    // 实现点击弹窗内容自身阻止冒泡，以防弹窗被关闭
    stopClose(e) {
      e.stopPropagation()
    },
    handleModelClose() {
      this.isModelData = false
      this.cutTimeTemp = ''
      this.cutTime = ''
      this.cutRightTime = ''
      this.curActive = true
    },
    confirmDataOk() {
      let dateTime = ''
      if (this.cutTime) {
        dateTime = `${this.cutTimeTemp}`
      }
      this.$emit('handleCalendar', dateTime)
      this.isModelData = false
      this.curActive = true
    },

    handleCalendar(value) {
      const date = new Date(value)
      const isMonday = date.getDay() === 1 // 判断是否为周一
      // 如果不是周一，禁用该日期
      if (!isMonday) {
        this.$toast('只能选择周一')
        return
      }
      this.cutTime = this.$moment(value * 1).format(
        'YYYY年MM月DD日'
      )
      this.cutTimeTemp = this.$moment(value * 1).format(
        'YYYY-MM-DD'
      )
    },
    handleLeftData() {
      this.curActive = true
      this.showModalLeftPicker = true
    },
  }
}
</script>

<style scoped lang="less">

.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);

  .model-data {
    width: 100%;
    box-sizing: border-box;
    height: 50vh;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;

    .model-head {
      display: flex;
      align-items: center;
      padding: 0 16px;
      height: 40px;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 3;
      background: #f2f1f5;

      .head-left {
        flex: 1;
        display: flex;
        align-items: center;

        .calendar {
          margin-right: 10px;
          font-size: 12px;
          line-height: 40px;
        }

        .active {
          border-bottom: 2px solid #727272;
        }
      }

      .close {
        color: #000000;
      }

      .head-title {
        flex: 1;
        text-align: center;
        font-weight: 600;
        color: #000000;
      }

      .ok {
        color: #EB1700;
      }
    }

    .model-main {
      padding: 0 16px 20px;
      // margin-top: 16px;
      .model-top {
        display: flex;
        align-items: center;

        .main-left {
          flex: 1;

          /deep/ .van-cell {
            height: 38px !important;
            border: 1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }

          /deep/ .van-field__control {
            line-height: 18px !important;
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            color: #AEAEAE;
          }
        }

        .hen {
          width: 6px;
          margin: 0 4px;

        }

        .main-right {
          flex: 1;

          /deep/ .van-cell {
            height: 38px !important;
            border: 1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }

          /deep/ .van-field__control {
            line-height: 18px !important;
          }
        }

        .startTime {
          /deep/ .van-field__control {
            color: #000;
            font-weight: 600;

            &::placeholder {
              color: #000;
              font-weight: 600;
            }
          }
        }
      }

      .model-btm {
        margin-top: 4px;
      }
    }

    /deep/ .van-popup, .van-picker {
      background: transparent !important;
    }

    /deep/ .van-popup {
      height: 45%;
    }

    /deep/ .van-picker__toolbar {
      display: none !important;
    }
  }
}

/* 自定义高亮样式 */
/deep/ .highlight-monday {
  color: #000 !important; /* 红色文字 */
  font-weight: bold !important; /* 加粗 */
  background-color: #fff3f3; /* 浅红色背景 */
}

/deep/ .highlight-disabled {
  color: #c8c9cc !important;
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/model-calendar.vue